module.exports = __webpack_public_path__ + "static/img/hy_v2.15413628.png";